import React, { useContext } from 'react';

import { useDeepEqualSelector, useQueryParam } from 'Shared/utils/hooks';
import ExpandNavbarContext from 'Shared/contexts/ExpandNavbarContext';
import QueryParamConstants from 'Shared/constants/QueryParams.constants';
import sortBy from 'lodash/sortBy';

import TeamGroupTemplate from '../TeamGroupTemplate/TeamGroupTemplate';
import GroupItem from '../GroupItem/GroupItem';
import EmptySectionState from '../EmptySectionState/EmptySectionState';
import AddGroupModalHandler from './AddGroupModalHandler/AddGroupModalHandler';
import { WpTooltip, WpTooltipContent, WpTooltipTrigger } from 'Wpds/components/tooltip';

import './GroupSection.scss';

type Props = {
  onCloseNavbar: Function;
};

function GroupSection({ onCloseNavbar }: Props) {
  const isExpanded = useContext(ExpandNavbarContext);
  const workspaces = useDeepEqualSelector(state => {
    const groupWorkspaces = state.workspaces.filter(({ starred, isGroup }) => !starred && isGroup);
    const resultList = [
      ...groupWorkspaces.filter(({ isTeamSync }) => isTeamSync),
      ...sortBy(
        groupWorkspaces.filter(({ isTeamSync }) => !isTeamSync),
        w => w.name.toLowerCase()
      ),
    ];
    return resultList;
  });

  const [, setAddGroupParam] = useQueryParam(QueryParamConstants.ADD_GROUP_WORKSPACE_MODAL);

  return (
    <div className="w-100">
      <AddGroupModalHandler onRedirectTo={() => setAddGroupParam(null)} />
      <TeamGroupTemplate
        title={
          <WpTooltip placement="top">
            <WpTooltipTrigger>
              <div className="d-flex align-items-center">Group Workspaces</div>
            </WpTooltipTrigger>
            <WpTooltipContent>
              Use group workspaces to collaborate on meetings agendas and action items with multiple people
            </WpTooltipContent>
          </WpTooltip>
        }
        addButtonLabel="Add Group Workspace"
        tooltipLabel="Add Group Workspace"
        onAddClick={() => setAddGroupParam(true)}
        onCloseNavbar={onCloseNavbar}
      >
        <div className="position-relative">
          <div>
            {workspaces.map(({ id, name, users, path, workspaceNotifications, starred }) => (
              <GroupItem
                key={id}
                workspaceId={id}
                name={name}
                users={users}
                path={path}
                onCloseNavbar={onCloseNavbar}
                showNewBadge={!workspaceNotifications?.viewedWorkspace}
                workspaceNotificationsCount={workspaceNotifications?.count}
                starred={starred}
              />
            ))}
            {Boolean(!workspaces.length) && isExpanded && (
              <EmptySectionState>Create a group for meetings and projects with more than one person</EmptySectionState>
            )}
          </div>
        </div>
      </TeamGroupTemplate>
    </div>
  );
}

export default GroupSection;
